// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/Vector.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-icon {
    display: inline-block;
    width: 20px; /* Set the width and height of your custom icon */
    height: 20px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Replace with the path to your custom icon */
    background-size: cover;
    cursor: pointer;
  }

  .react-datepicker__tab-loop{
    display: none;
  }
  
  .file-input-container {
    position: relative;
    display: inline-block;
    border: 1px solid #ccc; /* Set your desired border styles */
    border-radius: 4px;
  }
  
  .file-input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 0;
    height: 0;
    overflow: hidden;
  }`, "",{"version":3,"sources":["webpack://./src/components/pet-details/editpet.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,WAAW,EAAE,iDAAiD;IAC9D,YAAY;IACZ,yDAAuD,EAAE,8CAA8C;IACvG,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB,EAAE,mCAAmC;IAC3D,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,QAAQ;IACR,SAAS;IACT,gBAAgB;EAClB","sourcesContent":[".custom-icon {\n    display: inline-block;\n    width: 20px; /* Set the width and height of your custom icon */\n    height: 20px;\n    background-image: url('../../assets/images/Vector.png'); /* Replace with the path to your custom icon */\n    background-size: cover;\n    cursor: pointer;\n  }\n\n  .react-datepicker__tab-loop{\n    display: none;\n  }\n  \n  .file-input-container {\n    position: relative;\n    display: inline-block;\n    border: 1px solid #ccc; /* Set your desired border styles */\n    border-radius: 4px;\n  }\n  \n  .file-input {\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
